var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sponsored)?_c('div',{staticClass:"featured-icon"},[_vm._v(" "+_vm._s(_vm.sponsoredText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }